import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Elements } from '@stripe/react-stripe-js'
import { useLocation, useNavigate, Outlet, useParams } from 'react-router-dom'

import { selectActiveBuilding } from '../../../reducers/buildingSelectorReducer'
import { fetchLoyaltySettings } from '../../../reducers/loyaltyReducer'
import Dashboard from '../../Dashboard'

import RewardsToolbar from './RewardsToolbar'
import RewardsAddFundsModal from './RewardsAddFundsModal/RewardsAddFundsModal'
import RewardsLoyaltySettingsModal from './RewardsLoyaltySettingsModal/RewardsLoyaltySettingsModal'
import RewardsAddRewardModal from './RewardsAddRewardModal/RewardsAddRewardModal'
import SettingsToolbar from './SettingsToolbar'
import { stripePromise } from './helpers'

const Rewards = ({ selectedBuilding, fetchLoyaltySettings = () => {} }) => {
  const [isShowAddFunds, setShowAddFunds] = useState(false)
  const [isShowLoyaltySettings, setShowLoyaltySettings] = useState(false)
  const [isShowAddReward, setIsShowAddReward] = useState(false)

  const location = useLocation()
  const navigate = useNavigate()
  const { buildingId: paramBuildingId } = useParams()

  const isSettings = location.pathname.includes('/settings')

  const setParams = (buildingId) => {
    const path = location.pathname.includes('manage-inspection')
      ? '/dashboard/building-dashboard/rewards/'
      : '/dashboard/building-dashboard/rewards/dashboard'

    navigate(`${path}/${buildingId}`)
  }

  useEffect(() => {
    const buildingId = (selectedBuilding && selectedBuilding.id) || paramBuildingId

    if (paramBuildingId !== String(buildingId)) {
      setParams(buildingId)
    }

    if (selectedBuilding) {
      fetchLoyaltySettings(buildingId)
    }
  }, [selectedBuilding])

  const closePopup = () => {
    setShowAddFunds(false)
    setShowLoyaltySettings(false)
    setIsShowAddReward(false)
  }

  return (
    <Dashboard.Container className={'ctp-rewards'}>
      {isSettings ? (
        <SettingsToolbar onAddReward={() => setIsShowAddReward(true)} />
      ) : (
        <RewardsToolbar
          selectedBuilding={selectedBuilding}
          setShowAddFunds={setShowAddFunds}
          setShowLoyaltySettings={setShowLoyaltySettings}
        />
      )}
      <div className="ctp-rewards__inner" style={{ marginTop: isSettings ? 55 : 92 }}>
        <Outlet />
      </div>
      {isShowAddFunds && (
        <Elements stripe={stripePromise}>
          <RewardsAddFundsModal onClose={closePopup} selectedBuilding={selectedBuilding} />
        </Elements>
      )}
      {isShowLoyaltySettings && (
        <RewardsLoyaltySettingsModal onClose={closePopup} selectedBuilding={selectedBuilding} />
      )}
      {isShowAddReward && (
        <RewardsAddRewardModal onClose={closePopup} selectedBuilding={selectedBuilding} />
      )}
    </Dashboard.Container>
  )
}

Rewards.propTypes = {
  userData: PropTypes.object,
  children: PropTypes.element,
  selectedBuilding: PropTypes.object,
  fetchLoyaltySettings: PropTypes.func,
}

export default connect(
  (state) => ({
    selectedBuilding: selectActiveBuilding(state),
  }),
  {
    fetchLoyaltySettings,
  },
)(Rewards)
